import { signal } from 'services/SignalsService'
import { time } from 'settings/custom/win'
import { delay } from 'utils/Delay'

const name = 'WIN-SMALL'

export function getWinSmallAction(skip) {
  const spinModel = game.models.SpinModel.get()
  const freespinModel = game.models.FreespinModel.get()
  const winModel = game.models.WinModel.get()

  function execute() {
    const type = 'regular'
    const amount = winModel.linesWin

    signal.dispatch('WIN-COLLECT', { type, amount })

    return delay(skip && !freespinModel.add && !spinModel.respin.length ? 0 : time)
  }

  return {
    name,
    execute,
  }
}
